export default __webpack_public_path__ + "static/media/trophyInHand.2e26d974.svg";